import { request as requester } from 'sonata-react-components';

export async function getPlatform(token?: Record<string, any>): Promise<Record<string, any>> {
  return requester.makeRequest(
    `${taptap.config.backendUrlBase}platform`,
    {
      method: 'GET'
    },
    token
  );
}

export async function updatePlatformReloadForUser(userId: string, token?: Record<string, any>): Promise<any> {
  return requester.makeRequest(
    `${taptap.config.backendUrlBase}user/${userId}/platformUpdated`,
    {
      data: { status: true },
      method: 'POST'
    },
    token
  );
}
